import axios from 'axios'
import { chatwootAuth } from './chatwoot'
import type { ChatwootUser } from '@/types/chatwoot'

export interface SignInCredentials {
  email: string
  password: string
}

interface SignInResponse {
  data: ChatwootUser
}

export async function signIn(
  credentials: SignInCredentials,
): Promise<ChatwootUser> {
  const { data } = await chatwootAuth.post<SignInResponse>(
    '/sign_in',
    credentials,
  )
  return data.data
}

// /api/v1/profile não está sob o escopo /accounts/{id}, então usamos axios
// direto. O token é passado explicitamente (não vem do interceptor) porque
// este método é usado no fluxo SSO antes do auth store estar populado.
export async function fetchProfile(token: string): Promise<ChatwootUser> {
  const { data } = await axios.get<ChatwootUser>('/api/v1/profile', {
    headers: { api_access_token: token },
  })
  return data
}
